/**
 * Regex-based C# syntax highlighter (VS Dark+ colors).
 * Will be replaced by Shiki in Phase 5.
 */
export default function highlightCSharp(raw) {
  if (!raw) return '';

  return raw.split('\n').map(line => {
    let safe = line
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const commentMatch = safe.match(/^(.*?)(\/\/.*)$/s);
    let code = commentMatch ? commentMatch[1] : safe;
    const comment = commentMatch ? commentMatch[2] : '';

    // String literals
    code = code.replace(
      /("(?:[^"\\]|\\.)*")/g,
      '<span style="color:#CE9178">$1</span>'
    );
    // Keywords
    code = code.replace(
      /\b(using|namespace|class|static|void|string|int|bool|var|new|return|if|else|for|foreach|while|true|false|null)\b/g,
      '<span style="color:#569CD6">$1</span>'
    );
    // Known types
    code = code.replace(
      /\b(Program|Console|String|Int32|Boolean|Object)\b/g,
      '<span style="color:#4EC9B0">$1</span>'
    );
    // Known methods
    code = code.replace(
      /\b(Main|WriteLine|Write|ReadLine|Read)\b/g,
      '<span style="color:#DCDCAA">$1</span>'
    );
    // Numbers
    code = code.replace(/\b(\d+)\b/g, '<span style="color:#B5CEA8">$1</span>');

    const commentHtml = comment
      ? `<span style="color:#6A9955">${comment}</span>`
      : '';

    return code + commentHtml;
  }).join('\n');
}
